export const MODAL_PRODUCT_ACTIONS_ID = "modal-product-actions"
